import * as XLSX from 'xlsx'
import SheetManager from '../sheet-manager/sheet-manager.js'

export default class ExcelReader {
  constructor () {
    console.log('ExcelReader constructor')

    this.fileData = null

    this.workbook = null
  }

  async readFile (file) {
    console.log('ExcelReader readFile', file)

    const data = await file.arrayBuffer()
    this.fileData = data

    const parseOptions = {
      bookSheets: true
    }

    this.workbook = XLSX.read(data, parseOptions)

    this.sheetnames = this.workbook.SheetNames

    return this.workbook
  }

  getSheetNames () {
    return this.sheetnames
  }

  getSheet (sheetName) {
    return this.workbook.Sheets[sheetName]
  }

  /**
   * For an approximate sheet name, find the exact sheet name
   * @param {Array<String>|String} targetSheetName
   * @returns
   */
  findSheetname (targetSheetName) {
    const sheetname = this.sheetnames.find((sheet) => {
      return Array.isArray(targetSheetName)
        ? targetSheetName.includes(sheet.toLowerCase())
        : sheet.toLowerCase() === targetSheetName.toLowerCase()
    })
    return sheetname
  }

  readSheet (targetSheetName, cellsCoding = 'RC') {
    if (!this.fileData) return null

    const sheetjsOptions = {
      dense: cellsCoding === 'RC',
      sheets: [targetSheetName]
    }
    const workbook = XLSX.read(this.fileData, sheetjsOptions)
    const worksheet = workbook.Sheets[targetSheetName]

    return worksheet
  }

  readSheetToJson (targetSheetName) {
    const worksheet = this.readSheet(targetSheetName)

    const firstRow = 1

    const parseOptions = {
      header: 1, // 1: default first row values; A: column letters; row: row number? / Array[] array of names?
      range: firstRow
    }

    return XLSX.utils.sheet_to_json(worksheet, parseOptions)
  }

  readCells (targetSheetName) {
    const worksheet = this.readSheet(targetSheetName, 'A1')

    const sheetCells = []

    Object.keys(worksheet).forEach(function (key) {
      if (key.startsWith('!')) return

      const sheetCell = generateSheetCell(key, worksheet[key])
      sheetCells.push(sheetCell)
    })
    return sheetCells
  }
}

/**
 *
 * @param {*} cellA1ref
 * @param {*} cellObject
 * @returns {SheetCell}
 */
function generateSheetCell (refA1, cellObject) {
  // const address = XLSX.utils.decode_cell(refA1) // .r and .c as per SheetJS; ie 0-indexed

  const cellRefMeta = SheetManager.sheetCellRefMeta(refA1)
  // console.log(refA1, 'cellRefMeta', cellRefMeta)
  // console.log(refA1, 'cellObject', cellObject)

  const sheetCell = {
    ...cellRefMeta,
    refA1,
    value: cellObject.v,
    cellObject
  }

  // Methods:
  sheetCell.cellIsNumberNonZero = () => cellIsNumberNonZero(sheetCell)
  sheetCell.cellIsNumber = () => cellIsNumber(sheetCell)
  sheetCell.cellIsString = () => cellIsString(sheetCell)

  return sheetCell
}

function cellIsNumberNonZero (cell) {
  return Number.isFinite(cell?.value) && cell?.value !== 0
}

function cellIsNumber (cell) {
  return Number.isFinite(cell?.value)
}

function cellIsString (cell) {
  return typeof cell?.value === 'string' && cell?.value.length > 0
}
